var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardPlaceholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 26,
    viewBox: "0 0 42 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.474,16.35a2.512,2.512,0,0,1,1.917.824,2.475,2.475,0,0,1,.83,1.9V39.623a2.476,2.476,0,0,1-.83,1.9,2.508,2.508,0,0,1-1.917.824H8.968a2.509,2.509,0,0,1-1.917-.824,2.473,2.473,0,0,1-.83-1.9V19.077a2.474,2.474,0,0,1,.83-1.9,2.512,2.512,0,0,1,1.917-.824H45.474ZM8.968,18.506q-.32,0-.383.19a.547.547,0,0,0-.192.381v3.8H46.048v-3.8a.547.547,0,0,0-.192-.381q-.064-.19-.383-.19H8.968ZM45.474,40.194q.319,0,.383-.19a.547.547,0,0,0,.192-.381V29.35H8.392V39.623A.547.547,0,0,0,8.584,40q.063.19.383.19H45.474ZM10.565,38.037V35.818h4.408v2.219Zm6.58,0V35.818H23.66v2.219Z",
    transform: "translate(-6.221 -16.35)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPlaceholder);
export default __webpack_public_path__ + "static/media/cardPlaceholder.b60a1bebf0df9a81437c490c335af996.svg";
export { ForwardRef as ReactComponent };